import React from "react";
import { useSelector } from "react-redux";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import LivePTTrialPendingLogsStructure from "../../components/live-subscriptions/live-trials/LivePTTrialPendingLogsStructure";

const LivePTTrialPending = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Live PT Trial Pending Logs">
      <LivePTTrialPendingLogsStructure userInfoData={userInfoData} />;
    </HelmetWrapper>
  );
};

export default LivePTTrialPending;
